import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import DeletedCollective from "./DeleteCollectiveGroup";
import UpdateCollective from "./UpdateCollectiveGroup";

const server_backend = config.API_URL;

const CollectiveGroup = ({ username }) => {
    const [CollectiveList, setCollectiveList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onJobC_ID, setOnJobC_ID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState("");

    useEffect(() => {
        const getCollective = async () => {
            try {
                const response = await axios.get(`${server_backend}/Collective/list`, headers);
                
                if (response.data.RES_CODE === "00") {
                    setCollectiveList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getCollective();
    }, []);

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModal = () => {
        setIsUpdating(false);
    }

    const getCollective = async () => {
        try {
            const response = await axios.get(`${server_backend}/Collective/list`, headers);

            if (response.data.RES_CODE === "00") {
                setCollectiveList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    }

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
        const value = e.target.value;
        FilterCollective(value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);

        if (filtersEnabled) {
            FilterCollective();
        }
    };


    const handleColumnClick = (filterValue) => {
        if (filtersEnabled) {
            setSelectedFilter(filterValue);
            handleFilterByChange({ target: { value: filterValue } });
        }

    };

    const FilterCollective = async () => {
        try {
            const response = await axios.get(`${server_backend}/Collective/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setCollectiveList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterCollective();
        }
    }, [filterBy, filterStatus, filterValue]);

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                {!isUpdating ? (
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Collective Groups List</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><a href="javascript: void(0);">Option Job Category</a></li>
                                        <li className="breadcrumb-item active">List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <UpdateCollective username={username} onJobC_ID={onJobC_ID} onClose={CloseModal} getCollective={getCollective} />
                )}

                {!isUpdating && (
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card" id="tasksList">
                                <div className="card-header border-0">
                                    <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-0 flex-grow-1">Collective Groups</h5>
                                        <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                            <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                            </button>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <Link className="btn btn-danger add-btn" to="/create-collective-group">
                                                <i className="ri-add-line align-bottom me-1"></i> Create
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {filtersEnabled && (
                                    <div className="card-body border border-dashed border-end-0 border-start-0">
                                        <div className="row g-3">
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        name="choices-single-default"
                                                        disabled={!filtersEnabled}
                                                        value={filterBy}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option value="">Filter by</option>
                                                        <option value="colle_id">ID</option>
                                                        <option value="name">Name</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        data-choices
                                                        data-choices-search-false
                                                        name="choices-single-default"
                                                        id="idFilterStatus"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        <option value={1}>ACTIVATED</option>
                                                        <option value={2}>DISABLED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="search-box">
                                                    <input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder="Search for tasks or something..."
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterValueChange}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                )}

                                <div className="card-body">
                                    <div
                                        className="table-responsive table-card mb-4"
                                        style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
                                    >
                                        <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                            <thead className="table-light text-muted">
                                                <tr>
                                                    <th className="th-hover" onClick={() => handleColumnClick("colle_id")}>ID</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("name")}>Name</th>
                                                    <th className="th-hover" onClick={() => handleColumnClick("status")}>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody className="list form-check-all">
                                                {CollectiveList.map((JobC) => (
                                                    <tr key={JobC.colle_id}>
                                                        <th scope="row">
                                                            <div className="form-check">
                                                                {JobC.colle_id}
                                                            </div>
                                                        </th>

                                                        <td className="due_date">{JobC.name}</td>
                                                        <td className="status">
                                                            <span className={`${JobC.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                                {JobC.status_name}
                                                            </span>
                                                        </td>
                                                        <td className="due_date">
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item edit">
                                                                    <Link
                                                                        type="button"
                                                                        onClick={() => {
                                                                            ShowModalUpdate();
                                                                            setOnJobC_ID(JobC.colle_id);
                                                                        }}
                                                                        className="text-primary d-inline-block edit-item-btn"
                                                                    >
                                                                        <i className="ri-pencil-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                                <li className="list-inline-item" >
                                                                    <Link className="text-danger d-inline-block remove-item-btn" onClick={() => {
                                                                        DeletedCollective(JobC.colle_id, username, getCollective)
                                                                    }}>
                                                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row g-0 text-center text-sm-start">
                                        <div className="col-sm-6">
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="pagination-block pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CollectiveGroup;
